import { StateStorage } from 'zustand/middleware';
import storage from '../../../hooks/useStorage/useStorage';

export const orderBookPersistStorage = (teamId: string, isOfflineMode: boolean): StateStorage => {
  return {
    getItem: (_name: string) => {
      const data = storage.getOrderBookStore(teamId, isOfflineMode);

      if (!data) {
        return null;
      }

      return typeof data === 'string' ? data : JSON.stringify(data);
    },
    setItem: (_name: string, value: string) => {
      try {
        const orderBookStore = JSON.parse(value);
        storage.setOrderBookStore(orderBookStore, teamId, isOfflineMode);
      } catch (_err) {
        return;
      }
    },
    removeItem: (_name: string) => {
      storage.removeOrderBookStore(teamId, isOfflineMode);
    },
  };
};
